import { render, staticRenderFns } from "./MetadataNodeWrapper.vue?vue&type=template&id=117459f5"
import script from "./MetadataNodeWrapper.vue?vue&type=script&lang=js"
export * from "./MetadataNodeWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports